import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { useRedirect } from 'react-admin';
import { DeleteButton, EditLinkButton } from 'shared/mui/Buttons';
import { Card, CardActionsButtons } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { DeleteDialog } from 'shared/mui/Dialogs';
import { UserActionsIconButton } from 'shared/mui/IconButtons/UserActionsIconButton/UserActionsIconButton';
import { ApiClient } from 'types/embedded/apiClient';
import { Permission } from 'types/embedded/permission';

import { ApiClientsShowCommonInfoTable } from './ApiClientsShowCommonInfoTable';

type Props = {
  record?: ApiClient;
};

export const ApiClientsShowCommonInfo: React.FC<Props> = ({ record }) => {
  const { hasResourcePermissions, hasResourceAccess } = usePermissions();
  const redirect = useRedirect();
  const { handleCloseRecordModal, openRecordModal, handleOpenRecordModal } =
    useRecordModal<ApiClient>();

  return (
    <Card sx={{ border: '1px solid', borderColor: 'divider', width: '640px' }}>
      <CardHeader
        appendActions={
          hasResourceAccess(Resources.UserActions)
            ? [<UserActionsIconButton entityName="api_client" key="user-action-link" />]
            : undefined
        }
        title="Общая информация"
        titleSize="smallBold"
      />
      <CardContent>
        <ApiClientsShowCommonInfoTable />
      </CardContent>
      <CardActionsButtons
        rightActionsSlot={[
          hasResourcePermissions(Resources.ApiClients, [Permission.Full, Permission.Delete]) && (
            <DeleteButton onClick={() => handleOpenRecordModal()} variant="outlined" />
          ),
          hasResourcePermissions(Resources.ApiClients, [Permission.Full, Permission.Update]) && (
            <EditLinkButton variant="contained" />
          ),
        ]}
      />
      <DeleteDialog
        details={`Клиент API ${record?.name} будет удален без возможности восстановления.`}
        onClose={handleCloseRecordModal}
        onSuccess={() => redirect('list', Resources.ApiClients)}
        open={openRecordModal}
        record={record}
        title="Удаление клиента API"
      />
    </Card>
  );
};
